// @ts-nocheck
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .replace(/ß/g, 'ss');
  }

  function normalizeDuftKey(value) {
    return normalizeText(value)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getDuftKeyVariants(value) {
    const key = normalizeDuftKey(value);
    const variants = new Set([key]);

    if (key === 'suess') variants.add('suss');
    if (key === 'suss') variants.add('suess');
    if (key === 'wuerzig') variants.add('wurzig');
    if (key === 'wurzig') variants.add('wuerzig');

    return [...variants];
  }

  function getProductTagsList(product) {
    const raw = product?.tags;
    if (Array.isArray(raw)) {
      return raw.map((tag) => String(tag).trim()).filter(Boolean);
    }
    return String(raw || '')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
  }

  function getIngredientNamesFromTags(tags) {
    const names = new Set();
    getProductTagsList({ tags }).forEach((tag) => {
      if (!/^filter-ingr:\s*/i.test(tag)) return;
      const value = tag.replace(/^filter-ingr:\s*/i, '').trim();
      String(value)
        .split(/\s*[|,;/]\s*/)
        .map((item) => item.trim())
        .filter(Boolean)
        .forEach((name) => names.add(name));
    });
    return names;
  }

  function getDuftKeysFromTags(tags) {
    const keys = new Set();
    getProductTagsList({ tags }).forEach((tag) => {
      if (!/^filter-duft:\s*/i.test(tag)) return;
      const value = tag.replace(/^filter-duft:\s*/i, '').trim();
      String(value)
        .split(/\s*[|,;/]\s*/)
        .map((item) => normalizeDuftKey(item))
        .filter(Boolean)
        .forEach((key) => keys.add(key));
    });
    return keys;
  }

  function getIngredientKeysFromTags(tags) {
    const keys = new Set();
    getIngredientNamesFromTags(tags).forEach((name) => keys.add(normalizeDuftKey(name)));
    return keys;
  }

  function getFilterTagsFromElement(el) {
    const tags = [];
    const tagA = el.getAttribute('data-filter-tag-a');
    const tagB = el.getAttribute('data-filter-tag-b');
    if (tagA) tags.push(tagA);
    if (tagB && tagB !== tagA) tags.push(tagB);
    return tags;
  }

  function getFilterTagHandle(el) {
    return el.getAttribute('data-filter-tag-handle') || '';
  }

  function getIngredientKeysFromNode(node) {
    const keys = getIngredientKeysFromTags(getFilterTagsFromElement(node));
    const nameKey = normalizeDuftKey(node.getAttribute('data-name') || '');
    if (nameKey) keys.add(nameKey);
    return keys;
  }

  function productHasTag(tagsString, tagToFind) {
    const normalizedTag = String(tagToFind || '').trim().toLowerCase();
    if (!normalizedTag) return false;

    return String(tagsString || '')
      .split(',')
      .map((tag) => tag.trim().toLowerCase())
      .includes(normalizedTag);
  }

  function getIngredientLetter(name) {
    const first = normalizeText(String(name || '').trim()).charAt(0);
    if (!first || first < 'a' || first > 'z') return '';
    return first.toUpperCase();
  }

  function destroyProductCardSwipers(container) {
    window.__amDestroyCardSwipersIn?.(container);
  }

  const PRODUCT_INDEX_CACHE_KEY = 'am-sf-product-index';
  const PRODUCT_INDEX_CACHE_TTL_MS = 5 * 60 * 1000;

  function getProductIndexCacheKey(excludeProductTag) {
    return `${PRODUCT_INDEX_CACHE_KEY}:${String(excludeProductTag || '').trim()}`;
  }

  function readProductIndexCache(excludeProductTag) {
    try {
      const raw = sessionStorage.getItem(getProductIndexCacheKey(excludeProductTag));
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data?.ts || Date.now() - data.ts > PRODUCT_INDEX_CACHE_TTL_MS) return null;
      return data;
    } catch {
      return null;
    }
  }

  function writeProductIndexCache(excludeProductTag, productKeys, ingredientsByScent) {
    try {
      sessionStorage.setItem(
        getProductIndexCacheKey(excludeProductTag),
        JSON.stringify({
          ts: Date.now(),
          productKeys: [...productKeys],
          ingredientsByScent: Object.fromEntries(
            Object.entries(ingredientsByScent).map(([key, names]) => [key, [...names]])
          ),
        })
      );
    } catch {
      /* quota exceeded or private mode */
    }
  }

  function restoreProductIndexFromCache(data) {
    const productKeys = new Set(data.productKeys || []);
    const ingredientsByScent = {};
    Object.entries(data.ingredientsByScent || {}).forEach(([key, names]) => {
      ingredientsByScent[key] = new Set(names);
    });
    return { productKeys, ingredientsByScent };
  }

  function getRoutesRoot() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.root) || '/';
  }

  function getStickyScrollOffset() {
    const rootStyle = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-height')) || 0;
    const stickyOffset = parseFloat(rootStyle.getPropertyValue('--sticky-header-offset')) || 0;
    return Math.max(headerHeight, stickyOffset, 50) + 12;
  }

  function getIngredientNodes(root) {
    const grid = [...root.querySelectorAll('[data-am-scent-finder-ingredient]')];
    const accordions = [...root.querySelectorAll('[data-am-scent-finder-accordion-item]')];
    return [...new Set([...grid, ...accordions])];
  }

  function initProductCardSwipersWhenVisible(container) {
    window.__amInitCardSwipersIn?.(container);
  }

  let productFormScriptsPromise = null;

  function ensureProductFormScripts(scriptUrl) {
    if (customElements.get('product-form-component')) return Promise.resolve();
    if (!scriptUrl) return Promise.resolve();
    if (!productFormScriptsPromise) {
      productFormScriptsPromise = import(/* @vite-ignore */ scriptUrl).catch(() => {});
    }
    return productFormScriptsPromise;
  }

  function scheduleIdle(task) {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(() => task(), { timeout: 2000 });
      return;
    }
    setTimeout(task, 0);
  }

  class AmScentFinder {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-am-scent-finder-config]')?.textContent || '{}');
      this.cache = new Map();
      this.ingredientsByScent = {};
      this.ingredientProductKeys = new Set();
      this.ingredientProductIndexLoaded = false;
      this.activeIngredientKey = null;
      this.activeIngredientEl = null;

      this.pendingFilters = {
        search: '',
        letter: null,
        duftKeys: new Set(),
      };
      this.mobileDuftKey = '';

      this.ingredientNodes = getIngredientNodes(root);
      this.ingredientsPanel = root.querySelector('[data-am-scent-finder-ingredients-panel]');
      this.productsPanel = root.querySelector('[data-am-scent-finder-products-panel]');
      this.productsGrid = root.querySelector('[data-am-scent-finder-products-grid]');
      this.productsEmpty = root.querySelector('[data-am-scent-finder-products-empty]');
      this.loadingEl = root.querySelector('[data-am-scent-finder-loading]');
      this.noResultsEl = root.querySelector('[data-am-scent-finder-no-results]');
      this.accordionWrap = root.querySelector('[data-am-scent-finder-accordion-wrap]');
      this.banner = root.querySelector('[data-am-scent-finder-banner]');
      this.bannerImage = root.querySelector('[data-am-scent-finder-banner-image]');
      this.bannerName = root.querySelector('[data-am-scent-finder-banner-name]');
      this.bannerDesc = root.querySelector('[data-am-scent-finder-banner-desc]');

      this.sidebarSearch = root.querySelector('.am-scent-finder__sidebar [data-am-scent-finder-search]');
      this.mobileSearch = root.querySelector('.am-scent-finder__mobile-filters [data-am-scent-finder-search]');
      this.letterButtons = root.querySelectorAll('[data-am-scent-finder-letter]');
      this.duftButtons = root.querySelectorAll('[data-am-scent-finder-duft]');
      this.duftPills = root.querySelectorAll('[data-am-scent-finder-duft-pill]');
      this.applyBtn = root.querySelector('[data-am-scent-finder-apply]');
      this.resetBtn = root.querySelector('[data-am-scent-finder-reset]');
      this.clearBtns = root.querySelectorAll('[data-am-scent-finder-clear]');
      this.searchDebounceTimer = null;
      this.productLoadGeneration = 0;

      scheduleIdle(() => this.loadIngredientProductIndex());

      this.bindEvents();
      this.applyIngredientFilters();
    }

    isDesktop() {
      return DESKTOP_MQ.matches;
    }

    scrollOpenIngredientHeader(el) {
      if (!el) return;

      const run = () => {
        let target = null;

        if (this.isDesktop()) {
          if (this.banner && !this.banner.hidden) target = this.banner;
          else target = el;
        } else {
          target = el.querySelector('[data-am-scent-finder-accordion-trigger]') || el;
        }

        if (!target || target.hidden) return;

        const offset = getStickyScrollOffset();
        const top = window.scrollY + target.getBoundingClientRect().top - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      };

      requestAnimationFrame(() => requestAnimationFrame(run));
    }

    async loadIngredientProductIndex() {
      const excludeProductTag = String(this.config.excludeProductTag || '').trim();
      const cached = readProductIndexCache(excludeProductTag);
      if (cached) {
        const restored = restoreProductIndexFromCache(cached);
        this.ingredientProductKeys = restored.productKeys;
        this.ingredientsByScent = restored.ingredientsByScent;
        this.ingredientProductIndexLoaded = true;
        this.applyIngredientFilters();
        return;
      }

      const routesRoot = getRoutesRoot().replace(/\/$/, '');
      const productKeys = new Set();
      const scents = {};
      let page = 1;

      const indexProduct = (product) => {
        if (excludeProductTag && productHasTag(product.tags, excludeProductTag)) return;

        getIngredientKeysFromTags(product.tags).forEach((ingredientKey) => productKeys.add(ingredientKey));

        const duftKeys = getDuftKeysFromTags(product.tags);
        const ingredientNames = getIngredientNamesFromTags(product.tags);
        if (duftKeys.size === 0 || ingredientNames.size === 0) return;

        duftKeys.forEach((duftKey) => {
          if (!scents[duftKey]) scents[duftKey] = new Set();
          ingredientNames.forEach((name) => scents[duftKey].add(normalizeDuftKey(name)));
        });
      };

      try {
        while (page <= 20) {
          const url = `${routesRoot}/collections/all/products.json?limit=250&page=${page}`;

          const response = await fetch(url, { __skipRequestLoading: true });
          if (!response.ok) break;

          const data = await response.json();
          const products = Array.isArray(data.products) ? data.products : [];
          if (products.length === 0) break;

          products.forEach(indexProduct);

          if (products.length < 250) break;
          page += 1;
        }

        this.ingredientsByScent = scents;
        this.ingredientProductKeys = productKeys;
        this.ingredientProductIndexLoaded = true;
        writeProductIndexCache(excludeProductTag, productKeys, scents);
        this.applyIngredientFilters();
      } catch {
        /* fail open — ingredientProductIndexLoaded stays false */
      }
    }

    bindEvents() {
      this.ingredientNodes.forEach((node) => {
        if (node.matches('[data-am-scent-finder-ingredient]')) {
          node.addEventListener('click', () => this.onIngredientSelect(node));
        }
        if (node.matches('[data-am-scent-finder-accordion-item]')) {
          const trigger = node.querySelector('[data-am-scent-finder-accordion-trigger]');
          if (trigger) {
            trigger.addEventListener('click', () => this.onIngredientSelect(node));
          }
        }
      });

      this.letterButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const letter = btn.getAttribute('data-letter');
          const isActive = btn.getAttribute('aria-pressed') === 'true';
          this.letterButtons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
          if (!isActive && letter) {
            btn.setAttribute('aria-pressed', 'true');
            this.pendingFilters.letter = letter;
          } else {
            this.pendingFilters.letter = null;
          }
          this.pendingFilters.search = this.sidebarSearch?.value?.trim() || '';
          this.applyIngredientFilters();
        });
      });

      this.duftButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = normalizeDuftKey(btn.getAttribute('data-duft-key'));
          if (!key) return;
          const pressed = btn.getAttribute('aria-pressed') === 'true';
          btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
          if (pressed) {
            this.pendingFilters.duftKeys.delete(key);
          } else {
            this.pendingFilters.duftKeys.add(key);
          }
          this.pendingFilters.search = this.sidebarSearch?.value?.trim() || '';
          this.applyIngredientFilters();
        });
      });

      this.duftPills.forEach((pill) => {
        pill.addEventListener('click', () => {
          const key = normalizeDuftKey(pill.getAttribute('data-duft-key'));
          this.mobileDuftKey = key;
          this.duftPills.forEach((p) => {
            const active = p === pill;
            p.classList.toggle('is-active', active);
            p.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.applyIngredientFilters();
        });
      });

      if (this.applyBtn) {
        this.applyBtn.addEventListener('click', () => {
          this.pendingFilters.search = this.sidebarSearch?.value?.trim() || '';
          this.applyIngredientFilters();
        });
      }

      if (this.resetBtn) {
        this.resetBtn.addEventListener('click', () => this.resetAllFilters());
      }

      this.clearBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.clearSelection());
      });

      if (this.mobileSearch) {
        this.mobileSearch.addEventListener('input', () => {
          if (this.isDesktop()) return;
          this.scheduleFilterUpdate();
        });
      }

      if (this.sidebarSearch) {
        this.sidebarSearch.addEventListener('input', () => {
          if (!this.isDesktop()) return;
          this.scheduleFilterUpdate();
        });

        this.sidebarSearch.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
            this.pendingFilters.search = this.sidebarSearch.value.trim();
            this.applyIngredientFilters();
          }
        });
      }

      DESKTOP_MQ.addEventListener('change', () => {
        if (this.isDesktop() && this.activeIngredientKey) {
          this.setView('products');
        } else if (!this.isDesktop()) {
          this.setView('grid');
          if (this.productsPanel) this.productsPanel.setAttribute('data-hidden', 'true');
          if (this.banner) this.banner.hidden = true;
        }
      });
    }

    scheduleFilterUpdate() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.pendingFilters.search = this.isDesktop()
          ? this.sidebarSearch?.value?.trim() || ''
          : this.mobileSearch?.value?.trim() || '';
        this.applyIngredientFilters();
      }, 150);
    }

    getActiveFilterState() {
      if (this.isDesktop()) {
        return {
          search: this.pendingFilters.search,
          letter: this.pendingFilters.letter,
          duftKeys: [...this.pendingFilters.duftKeys],
        };
      }
      return {
        search: this.mobileSearch?.value?.trim() || '',
        letter: null,
        duftKeys: this.mobileDuftKey ? [this.mobileDuftKey] : [],
      };
    }

    ingredientHasProducts(node) {
      if (!this.config.hideIngredientsWithoutProducts) return true;
      if (!this.ingredientProductIndexLoaded) return true;

      for (const key of getIngredientKeysFromNode(node)) {
        if (this.ingredientProductKeys.has(key)) return true;
      }
      return false;
    }

    ingredientMatchesFilters(node, filters) {
      const rawName = node.getAttribute('data-name') || '';
      const name = normalizeText(rawName);

      if (!this.ingredientHasProducts(node)) return false;

      if (filters.search) {
        const q = normalizeText(filters.search);
        if (!name.includes(q)) return false;
      }

      if (filters.letter && getIngredientLetter(rawName) !== filters.letter) return false;

      if (filters.duftKeys.length > 0) {
        if (!this.ingredientProductIndexLoaded) return true;

        const ingredientKey = normalizeDuftKey(rawName);
        const hasMatch = filters.duftKeys.some((duftKey) =>
          getDuftKeyVariants(duftKey).some((variant) => {
            const names = this.ingredientsByScent[variant];
            return names && names.has(ingredientKey);
          })
        );
        if (!hasMatch) return false;
      }

      return true;
    }

    applyIngredientFilters() {
      const filters = this.getActiveFilterState();
      const visibleHandles = new Set();

      this.ingredientNodes.forEach((node) => {
        const match = this.ingredientMatchesFilters(node, filters);
        node.hidden = !match;
        if (match) {
          const handle = node.getAttribute('data-ingredient-handle');
          if (handle) visibleHandles.add(handle);
        }
      });

      const visibleCount = visibleHandles.size;
      const showNoFilterResults = visibleCount === 0 && this.ingredientNodes.length > 0;

      if (this.noResultsEl) {
        this.noResultsEl.hidden = !showNoFilterResults;
        if (showNoFilterResults && this.config.noFilterResultsMessage) {
          this.noResultsEl.textContent = this.config.noFilterResultsMessage;
        }
      }

      if (this.accordionWrap) {
        this.accordionWrap.hidden = !this.isDesktop() && showNoFilterResults;
      }

      if (this.activeIngredientEl?.hidden) {
        this.clearSelection();
      }
    }

    resetAllFilters() {
      this.pendingFilters = { search: '', letter: null, duftKeys: new Set() };
      this.mobileDuftKey = '';

      if (this.sidebarSearch) this.sidebarSearch.value = '';
      if (this.mobileSearch) this.mobileSearch.value = '';

      this.letterButtons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      this.duftButtons.forEach((b) => b.setAttribute('aria-pressed', 'false'));

      this.duftPills.forEach((pill) => {
        const isAll = !pill.getAttribute('data-duft-key');
        pill.classList.toggle('is-active', isAll);
        pill.setAttribute('aria-pressed', isAll ? 'true' : 'false');
      });

      this.clearSelection();
      this.applyIngredientFilters();
    }

    clearSelection() {
      this.activeIngredientKey = null;
      this.activeIngredientEl = null;
      this.setView('grid');

      if (this.productsPanel) this.productsPanel.setAttribute('data-hidden', 'true');
      if (this.banner) this.banner.hidden = true;
      if (this.productsGrid) {
        destroyProductCardSwipers(this.productsGrid);
        this.productsGrid.innerHTML = '';
      }
      if (this.productsEmpty) this.productsEmpty.hidden = true;

      this.root.querySelectorAll('[data-am-scent-finder-ingredient]').forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });

      this.root.querySelectorAll('[data-am-scent-finder-accordion-item]').forEach((item) => {
        item.classList.remove('is-expanded');
        const trigger = item.querySelector('[data-am-scent-finder-accordion-trigger]');
        const panel = item.querySelector('[data-am-scent-finder-accordion-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
        const mobileGrid = item.querySelector('[data-am-scent-finder-mobile-products]');
        if (mobileGrid) {
          destroyProductCardSwipers(mobileGrid);
          mobileGrid.innerHTML = '';
        }
      });
    }

    setView(view) {
      this.root.setAttribute('data-view', view);
    }

    onIngredientSelect(el) {
      const key = el.getAttribute('data-ingredient-handle');
      if (!key) return;

      if (!this.isDesktop() && el.matches('[data-am-scent-finder-accordion-item]') && el.classList.contains('is-expanded')) {
        this.collapseMobileAccordion(el);
        return;
      }

      this.activeIngredientKey = key;
      this.activeIngredientEl = el;

      this.root.querySelectorAll('[data-am-scent-finder-ingredient]').forEach((btn) => {
        const active = btn.getAttribute('data-ingredient-handle') === key;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (this.isDesktop()) {
        this.setView('products');
        if (this.productsPanel) this.productsPanel.setAttribute('data-hidden', 'false');
        this.updateBanner(el);
        this.scrollOpenIngredientHeader(el);
        this.loadProducts(el, this.productsGrid);
      } else {
        this.selectMobileAccordion(el);
        this.scrollOpenIngredientHeader(el);
        this.loadProducts(el, this.getMobileProductsGrid(el));
      }
    }

    collapseMobileAccordion(el) {
      el.classList.remove('is-expanded');
      const trigger = el.querySelector('[data-am-scent-finder-accordion-trigger]');
      const panel = el.querySelector('[data-am-scent-finder-accordion-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      const mobileGrid = el.querySelector('[data-am-scent-finder-mobile-products]');
      if (mobileGrid) {
        destroyProductCardSwipers(mobileGrid);
        mobileGrid.innerHTML = '';
      }

      if (this.activeIngredientEl === el) {
        this.activeIngredientKey = null;
        this.activeIngredientEl = null;
      }
    }

    selectMobileAccordion(el) {
      this.root.querySelectorAll('[data-am-scent-finder-accordion-item]').forEach((item) => {
        const isActive = item === el;
        item.classList.toggle('is-expanded', isActive);
        const trigger = item.querySelector('[data-am-scent-finder-accordion-trigger]');
        const panel = item.querySelector('[data-am-scent-finder-accordion-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        if (panel) panel.hidden = !isActive;
        if (!isActive) {
          const mobileGrid = item.querySelector('[data-am-scent-finder-mobile-products]');
          if (mobileGrid) {
            destroyProductCardSwipers(mobileGrid);
            mobileGrid.innerHTML = '';
          }
        }
      });
    }

    getMobileProductsGrid(el) {
      return el.querySelector('[data-am-scent-finder-mobile-products]');
    }

    updateBanner(el) {
      if (!this.banner) return;
      const name = el.getAttribute('data-name') || '';
      const description = el.getAttribute('data-description') || '';
      const imageUrl = el.getAttribute('data-image-url') || '';

      if (this.bannerName) this.bannerName.textContent = name;
      if (this.bannerDesc) {
        this.bannerDesc.textContent = description;
        this.bannerDesc.hidden = !description;
      }
      if (this.bannerImage) {
        this.bannerImage.replaceChildren();
        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = name;
          img.width = 80;
          img.height = 80;
          img.loading = 'lazy';
          this.bannerImage.appendChild(img);
        }
      }
      this.banner.hidden = false;
    }

    async loadProducts(el, targetGrid) {
      if (!targetGrid) return;

      const key = el.getAttribute('data-ingredient-handle');
      if (!key) return;

      const loadId = ++this.productLoadGeneration;
      const isMobileGrid = targetGrid.matches('[data-am-scent-finder-mobile-products]');
      const panelLoading = isMobileGrid ? el.querySelector('[data-am-scent-finder-panel-loading]') : null;

      if (panelLoading) panelLoading.hidden = false;
      else if (!isMobileGrid && this.loadingEl) this.loadingEl.hidden = false;
      if (this.productsEmpty) this.productsEmpty.hidden = true;
      destroyProductCardSwipers(targetGrid);
      targetGrid.innerHTML = '';

      try {
        if (!this.cache.has(key)) {
          const filterTags = getFilterTagsFromElement(el);
          const tagHandle = getFilterTagHandle(el);
          const items = await this.fetchProductsForTags(filterTags, tagHandle);
          this.cache.set(key, items);
        }

        if (loadId !== this.productLoadGeneration || this.activeIngredientKey !== key) return;

        await ensureProductFormScripts(this.config.productFormScriptUrl);

        if (loadId !== this.productLoadGeneration || this.activeIngredientKey !== key) return;

        this.renderProducts(this.cache.get(key) || [], targetGrid);
      } catch {
        if (loadId !== this.productLoadGeneration || this.activeIngredientKey !== key) return;
        this.renderProducts([], targetGrid);
      } finally {
        if (loadId !== this.productLoadGeneration) return;
        if (panelLoading) panelLoading.hidden = true;
        if (!isMobileGrid && this.loadingEl) this.loadingEl.hidden = true;
      }
    }

    async fetchProductsForTags(filterTags, tagHandle) {
      const collectionHandle = 'all';
      const sectionId = this.config.productsSectionId || 'am-scent-finder-products';
      const routesRoot = getRoutesRoot().replace(/\/$/, '');
      const excludeProductTag = String(this.config.excludeProductTag || '').trim();
      const seenHandles = new Set();
      const items = [];

      const urlTag = tagHandle || (filterTags[0] ? encodeURIComponent(filterTags[0]) : '');
      if (!urlTag) return items;

      const collectionUrl = new URL(`${routesRoot}/collections/${collectionHandle}/${urlTag}`, window.location.origin);
      collectionUrl.searchParams.set('section_id', sectionId);

      const response = await fetch(collectionUrl.toString(), { __skipRequestLoading: true });
      if (!response.ok) {
        return items;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const productItems = doc.querySelectorAll('.am-scent-finder-products__item[data-product-id]');

      for (const productEl of productItems) {
        const handle = productEl.getAttribute('data-sf-handle');
        if (!handle || seenHandles.has(handle)) continue;
        if (excludeProductTag && productHasTag(productEl.getAttribute('data-sf-tags'), excludeProductTag)) {
          continue;
        }

        seenHandles.add(handle);
        items.push(productEl);
      }

      return items;
    }

    renderProducts(items, grid) {
      if (!grid) return;
      grid.innerHTML = '';

      if (items.length === 0) {
        if (grid.matches('[data-am-scent-finder-mobile-products]')) {
          const emptyItem = document.createElement('li');
          emptyItem.className = 'am-scent-finder__products-empty-item';
          const emptyText = document.createElement('p');
          emptyText.className = 'am-scent-finder__products-empty';
          emptyText.textContent = this.config.noProductsMessage || '';
          emptyItem.appendChild(emptyText);
          grid.appendChild(emptyItem);
        } else if (this.productsEmpty && grid === this.productsGrid) {
          this.productsEmpty.hidden = false;
        }
        return;
      }

      if (this.productsEmpty) this.productsEmpty.hidden = true;

      items.forEach((el) => {
        const li = el.cloneNode(true);
        li.hidden = false;
        grid.appendChild(li);
      });

      initProductCardSwipersWhenVisible(grid);
    }
  }

  function init() {
    document.querySelectorAll('[data-am-scent-finder]').forEach((root) => {
      if (root.dataset.amScentFinderInit === 'true') return;
      root.dataset.amScentFinderInit = 'true';
      new AmScentFinder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
